let vapidPublicKey = process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY || '';

const isIOS = () => {
  if (typeof navigator === 'undefined') return false;
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

const isAndroid = () => {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent);
};

const isChrome = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return ua.includes('Chrome') && !ua.includes('Edg');
};

const needsStandaloneIOS = () => {
  if (typeof window === 'undefined') return false;
  return isIOS() && !window.matchMedia('(display-mode: standalone)').matches;
};

export const setVapidPublicKey = (key) => {
  vapidPublicKey = key || '';
};

export const getPushSupportStatus = () => {
  try {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return { supported: false, reason: 'unknown' };
    }
    
    if (!('Notification' in window)) {
      return { supported: false, reason: 'notification' };
    }
    
    if (needsStandaloneIOS()) {
      return { supported: false, reason: 'iosStandalone' };
    }
    
    if (!('serviceWorker' in navigator)) {
      return { supported: false, reason: 'serviceWorker' };
    }
    
    if (!vapidPublicKey) {
      return { supported: false, reason: 'missingKey' };
    }
    
    return { supported: true };
  } catch (error) {
    return { supported: false, reason: 'unknown' };
  }
};

export const isPushSupported = () => getPushSupportStatus().supported;

export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker desteklenmiyor');
  }

  try {
    const registration = await navigator.serviceWorker.register('/notification-sw.js', {
      scope: '/'
    });
    return registration;
  } catch (error) {
    throw new Error(`Service Worker kaydı başarısız: ${error.message}`);
  }
};

export const subscribeToPush = async (registration) => {
  if (!vapidPublicKey) {
    throw new Error('VAPID public key tanımlı değil');
  }

  if (!('PushManager' in window)) {
    throw new Error('Push Manager desteklenmiyor');
  }

  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });
    return subscription;
  } catch (error) {
    if (error.name === 'NotAllowedError') {
      throw new Error('Bildirim izni verilmedi');
    }
    throw new Error(`Push aboneliği başarısız: ${error.message}`);
  }
};

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export { isIOS, isAndroid, isChrome };


